var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cpn-loading',{attrs:{"show":_vm.loading}}),(!_vm.loading)?_c('div',{staticClass:"pa-5"},[_c('div',[_vm._v(" old website : 3,900 ")]),_c('div',[_vm._v(" new website : "+_vm._s(_vm.items.total)+" ")]),_c('div',[_vm._v(" All : "+_vm._s(_vm.returncommaNumber(_vm.items.total+3900))+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }